export const STRIPE_PUBLIC_KEY = 'undefined';

/**
 * Stripe plan type
 */
export const PLAN_TYPE = {
    MONTHLY: 'monthly',
    ANNUAL: 'annual'
};
